<template>
<el-autocomplete
  class="inline-input"
  prefix-icon="el-icon-search"
  v-model="txtValue"
  :fetch-suggestions="querySearch"
  :placeholder="placeHolder"
/>
</template>
<script>
export default {
  name: 'Search',
  props:{
    datas: {
      type: Array
    },
    placeHolder: {
      type: String
    },
    searchWord:{
      type: String
    }
  },
  data() {
    return {
      txtValue: '',
    }
  },
  computed:{
    selectItems: function() {
      //将传入数组转为element-ui指定格式数组:{'value': 值}
      //数据量大是，不能用computed转换，有bug
      return this.datas.map(item=>{
        return {
          'value': item
        }
      })
    }
  },
  methods: {
    querySearch(queryStr, cb){
      const that = this
      //过滤以查询参数开头的元素
      let filteredDatas = queryStr ? that.selectItems.filter(that.filterStartWith(queryStr)) : that.selectItems
      // 调用 callback 返回建议列表的数据
      cb(filteredDatas)
    },
    //返回过滤函数闭包
    //过滤以查询参数开头的元素
    filterStartWith(queryStr){
      return (data) =>{
        return data.value.toLowerCase().indexOf(queryStr.toLowerCase()) === 0 
      }
    }
  },
  watch: {
    txtValue: function(){
      this.$emit('update:searchWord', this.txtValue)
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>